import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

import {
  DeepPartial,
  ExpandedHuntPackageRecord,
  HuntPackageRecord,
} from '@cyborg-monorepo/hunter/common'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'
import { UpdatedHuntPackage } from '../../hunt/hunt-template/custom-hunt-package/updated-hunt-package-interface'

@Injectable({
  providedIn: 'root',
})
export class CustomHuntPackageService {
  private httpClient = inject(HttpClient)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  private apiUrl: string = this.verityEnvironmentService.apiUrl + '/v2'

  private refreshListSubject = new BehaviorSubject<boolean>(false)
  public refreshList$ = this.refreshListSubject.asObservable()

  public triggerRefresh(): void {
    this.refreshListSubject.next(true)
  }

  public getCustomContentByUUID = (
    huntTemplateId: string,
    customHuntPackageUUID: string,
  ): Observable<HuntPackageRecord> => {
    return this.httpClient.get<HuntPackageRecord>(
      `${this.apiUrl}/hunt-template/${huntTemplateId}/custom-hunt-package/${customHuntPackageUUID}`,
    )
  }

  public updateCustomHuntPackage(
    huntTemplateId: string,
    huntPackage: DeepPartial<UpdatedHuntPackage>,
  ): Observable<ExpandedHuntPackageRecord> {
    return this.httpClient.patch<ExpandedHuntPackageRecord>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-custom-hunt-package/${huntTemplateId}/update-hunt-package`,
      huntPackage,
    )
  }
}
